/* oxlint-disable typescript/consistent-return -- LINTER migration follow up */
import { useEffect, useState } from "react";

// Add a small threshold to account for subpixel rounding
const THRESHOLD = 2;

export function useOverflow(
  ref: React.RefObject<HTMLElement | null>,
  boundaryRef?: React.RefObject<HTMLElement | null>,
): boolean {
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    const target = boundaryRef?.current ?? el;

    const checkOverflow = (): void => {
      // oxlint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect
      setIsOverflowing(
        el.scrollWidth > target.clientWidth + THRESHOLD || el.scrollHeight > target.clientHeight + THRESHOLD,
      );
    };

    checkOverflow();

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);
    if (target !== el) {
      observer.observe(target);
    }

    return () => observer.disconnect();
  }, [ref, boundaryRef]);

  return isOverflowing;
}
